import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'

@Component({
  selector: 'app-view-button-column-renderer',
  template: `
    <button class="btn btn-link" style="padding: 0; margin-right: 15px;" (click)="viewClicked()">
      <i class="fa fa-search"></i> View
    </button>
  `,
  standalone: false
})
export class ViewButtonColumnRendererComponent implements AgRendererComponent {
  private params: any

  agInit(params: any): void {
    this.params = params
  }

  refresh(): boolean {
    return false
  }

  public viewClicked(): void {
    if (this.params.context.viewHandler) {
      this.params.context.viewHandler(this.params.data)
    }
  }
}
